import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useCreateQuotation } from '~/api/quotations';
import { Container, Header } from '~/components';
import { productFruitsIds } from '~/constants/productFruits';
import { r, routes } from '~/providers/RouterProvider/router.routes';
import { toast } from '~/utils/toast';

import { QuotationsTable } from './QuotationsTable';

export const QuotationsOverview = () => {
  const createDraftQuotationMutation = useCreateQuotation();

  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'quotations']);

  const createDraftQuotation = () => {
    createDraftQuotationMutation.mutate(undefined, {
      onSuccess: ({ id }) => navigate(r(routes.createQuotation, { quotationId: id })),
      onError: () => toast.danger({ description: t('common:error') }),
    });
  };

  return (
    <>
      <Header.Root>
        <Header.Content title={t('quotations:header.title')} />

        <Header.Actions>
          <Header.Action
            data-pf-id={productFruitsIds.quotations.header.createQuotation}
            icon="Add"
            loading={createDraftQuotationMutation.isPending}
            onClick={createDraftQuotation}
          >
            {t('quotations:header.actionBlock.button')}
          </Header.Action>
        </Header.Actions>
      </Header.Root>

      <Container>
        <QuotationsTable />
      </Container>
    </>
  );
};
